// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chevron-up.js';

import { paths } from '../generated/chevron-up';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chevron-up', Original, paths);
